import React, { useEffect, useState } from "react";
import Header from "../layout/header";
import callingAPI from "../service"
import { useNavigate } from 'react-router-dom';
import Eye from "../images/eye.png"
import HideEye from "../images/hide.png"
import { TiArrowRight } from "react-icons/ti";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setDashboardData, clearDashboardData } from "../redux/reducers/dashboardSlice";


export default function ChangePwd() {
  const dispatch = useDispatch();
  const dashboardDetails = useSelector((state) => state.Dashboard);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const userId = dashboardDetails.userId
  const isPasswordExpired = dashboardDetails.passwordExpired
  const [passwordStrength, setPasswordStrength] = useState("");
  const [isPasswordVisibleNew, setIsPasswordVisibleNew] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isPasswordVisibleCurrent, setIsPasswordVisibleCurrent] = useState(false);
  const maxlength = newPassword.length >= 12
  const minLength = newPassword.length >= 10;
  const hasUppercase = /[A-Z]/.test(newPassword);
  const hasNumber = /[0-9]/.test(newPassword);
  const refreshToken = dashboardDetails.refreshToken;

  var userLogId = ""
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(
      setDashboardData({
        moduleId: 4,
        userlogId: ""
      })
    );
    handleUserLog()
    return () => {
      handleUserLog();
    };
  }, []);
  const handleUserLog = () => {
    const postData = {
      "userId": userId,
      "isApp": "false",
      "moduleId": 4,
      "previousPage": dashboardDetails.previousPage,
      "userSession": refreshToken,
      "userLogId": userLogId
    }
    callingAPI(postData, "user/userLog", 'post')
      .then((response) => {
        const { data } = response;
        if (data.statusCode === 200) {
          userLogId = data.data.userLogId
          dispatch(
            setDashboardData({
              previousPage: 4,
            })
          );
        }
        else {
          userLogId = ""
        }
      })
      .catch((error) => {
        console.error('Error during profile fetch:', error);
      });
  }
  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };
  const togglePasswordVisibilityNew = () => {
    setIsPasswordVisibleNew(!isPasswordVisibleNew);
  };
  const togglePasswordVisibilityCurrent = () => {
    setIsPasswordVisibleCurrent(!isPasswordVisibleCurrent);
  };
  useEffect(() => {
    if (newPassword !== "" && newPassword.length >= 8) {
      const strength1 = validatePasswordStrength(newPassword);
      setPasswordStrength(strength1);
    }
    else {
      setErrorMessage("");
      setPasswordStrength("");
    }
  }, [newPassword]);

  const validatePasswordStrength = (password) => {
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    if (maxlength === true && hasUppercase && hasNumber && hasSpecialChar) {
      return "strong";
    } else if (minLength === true && (hasUppercase || hasNumber || hasSpecialChar)) {
      return "medium";
    } else {
      return "weak";
    }
  };

  const handleFieldFocus = () => {
    setErrorMessage("");
  };

  const handleSubmit = async () => {
    setErrorMessage("");
    setSuccessMessage("");
    const maxlength = newPassword.length >= 8
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(newPassword);
    if (!currentPassword) {
      setErrorMessage("Current Password Required");
      return;
    }
    else if (!newPassword) {
      setErrorMessage("New Password Required");
      return;
    }

    else if (maxlength == false || !hasUppercase || hasNumber == false || !hasSpecialChar) {
      setErrorMessage("Invalid Password");
      return false;
    }
    else if (!confirmPassword) {
      setErrorMessage("Confirm Password Required");
      return;
    }
    else if (newPassword !== confirmPassword) {
      setErrorMessage("New password and confirm password do not match.");
      return;
    }
    const postData = {
      "userId": userId,
      "oldPassword": currentPassword,
      "newPassword": confirmPassword,
      //"refreshToken": refreshToken
    };
    console.log("🚀 ~ handleSubmit ~ postData:", postData)
    try {
      const response = await callingAPI(postData, "user/changePassword", 'post');
      const { data } = response;
      if (data.statusCode === 200) {
        setSuccessMessage("Password changed successfully.");
        setErrorMessage("");
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");

        setTimeout(() => {
          setSuccessMessage("");
        }, 3000);
        if (isPasswordExpired === "1") {
          dispatch(clearDashboardData());
          setSuccessMessage("Password changed successfully.");

          setTimeout(() => {
            navigate('/');
          }, 3000);

        }
      } else {
        console.error('Password change failed with status code:', data.statusCode);
        setErrorMessage(data.message);
      }
    } catch (error) {
      if (error.response && error.response.data) {
        const { message, statusCode } = error.response.data;
        console.error('Error during password change:', statusCode, message);
        setErrorMessage(message);
      } else {
        console.error('Error during password change:', error);
        setErrorMessage(error.message);
      }
    }
  };

  return (
    <div className="main-wrapper">
      <div className="top-outer">
        <Header />
      </div>
      <div className="container-fluid position-relative">
        <div className="m-auto col-lg-5 col-md-8 mt-5 col-12 change-pwd-page">
          {isPasswordExpired === "1" ?
            <div className="pass-expiredMsg">Your password has expired. Please reset your password to continue.</div>
            : ""}
          <div className="card card-outline-secondary">
            <div className="card-header">
              <h3 className="mb-0 login-head">Change Password</h3>
            </div>
            <div className="card-body">
              {errorMessage && <div className="err-msg">{errorMessage}</div>}
              {successMessage && <div className="success-msg">{successMessage}</div>}
              <div className="form" role="form" autoComplete="off">
                <div className="form-group mb-3">
                  <label htmlFor="inputPasswordOld" className="form-label">
                    Current Password <span className="text-danger">*</span>
                  </label>
                  <div className="Right-Icon">
                    <input
                      type={isPasswordVisibleCurrent ? 'text' : 'password'}
                      className="form-control"
                      id="inputPasswordOld"
                      required
                      placeholder="Enter Current Password"
                      value={currentPassword}
                      onChange={(e) => setCurrentPassword(e.target.value)}
                      onFocus={handleFieldFocus}
                    />
                    <div className="eye-show" onClick={togglePasswordVisibilityCurrent}>
                      <img
                        src={isPasswordVisibleCurrent ? HideEye : Eye}
                        alt="Toggle Password Visibility"
                        className="img-fluid"
                        width="15"
                        height="15"
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="inputPasswordNew" className="form-label">
                    New Password <span className="text-danger">*</span>
                  </label>
                  <div className="Right-Icon">
                    <input
                      type={isPasswordVisibleNew ? 'text' : 'password'}
                      className="form-control"
                      id="inputPasswordNew"
                      required
                      placeholder="Enter New Password"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                    />
                    <div className="eye-show" onClick={togglePasswordVisibilityNew}>
                      <img
                        src={isPasswordVisibleNew ? HideEye : Eye}
                        alt="Toggle Password Visibility"
                        className="img-fluid"
                        width="15"
                        height="15"
                      />
                    </div>
                    {passwordStrength === "weak" && (
                      <>
                        <div className="d-flex" style={{ gap: "7px" }}>
                          <div className="bar-weak"></div>
                          <div className="bar-default"></div>
                          <div className="bar-default"></div>
                        </div>
                        <div className="pass-valid-text color-red">Weak</div>
                      </>
                    )}
                    {passwordStrength === "medium" && (
                      <>
                        <div className="d-flex" style={{ gap: "7px" }}>
                          <div className="bar-medium"></div>
                          <div className="bar-medium"></div>
                          <div className="bar-default"></div>
                        </div>
                        <div className="pass-valid-text color-yellow">Medium</div>
                      </>
                    )}
                    {passwordStrength === "strong" && (
                      <>
                        <div className="d-flex" style={{ gap: "7px" }}>
                          <div className="bar-strong"></div>
                          <div className="bar-strong"></div>
                          <div className="bar-strong"></div>
                        </div>
                        <div className="pass-valid-text color-green">Strong</div>
                      </>
                    )}
                  </div>
                </div>
                {/* <p className="change-passwrd-text">Password must be at least 8 characters long, include an uppercase letter, a number, and a special character. Password must be different from your last 5 passwords.</p> */}
                <div className="form-group mb-1">
                  <label htmlFor="inputPasswordConfirm" className="form-label">
                    Confirm Password <span className="text-danger">*</span>
                  </label>
                  <div className="Right-Icon">
                    <input
                      type={isPasswordVisible ? 'text' : 'password'}
                      className="form-control"
                      id="inputPasswordConfirm"
                      required
                      placeholder="Enter Confirm Password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      onFocus={handleFieldFocus}
                    />
                    <div className="eye-show" onClick={togglePasswordVisibility}>
                      <img
                        src={isPasswordVisible ? HideEye : Eye}
                        alt="Toggle Password Visibility"
                        className="img-fluid"
                        width="15"
                        height="15"
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group d-flex justify-content-center mt-2">
                  <button type="button" className="btn-save" onClick={handleSubmit}>
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-3 password-container-div">
          <div className="pwd-mustbe">Password must be</div>
          <p className="pwd-text-info">
            <span className="me-2">
              <TiArrowRight fontSize={19} />
            </span>
            At least 8 characters long.
          </p>
          <p className="pwd-text-info">
            <span className="me-2">
              <TiArrowRight fontSize={19} />
            </span>
            Include an uppercase letter.
          </p>
          <p className="pwd-text-info">
            <span className="me-2">
              <TiArrowRight fontSize={19} />
            </span>
            A number.
          </p>
          <p className="pwd-text-info">
            <span className="me-2">
              <TiArrowRight fontSize={19} />
            </span>
            A special character.
          </p>
          <p className="pwd-text-info">
            <span className="me-2">
              <TiArrowRight fontSize={19} />
            </span>
            Different from your last 5 passwords.
          </p>
        </div>
      </div>
    </div>
  );
}
